import { z } from 'zod';

export enum IntegrationSources {
  ASANA = 'asana',
  XRAY_CLOUD = 'xrayCloud',
  JIRA = 'jira',
  AZURE_DEVOPS = 'azureDevops',
  TESTRAIL = 'testrail',
  SALESFORCE = 'salesforce',
  ZEPHYR_SCALE = 'zephyrScale',
  ONEDRIVE = 'onedrive',
  ONEDRIVE_BUSINESS = 'onedrive-business',
}

export const IntegrationItems = z.nativeEnum(IntegrationSources);

export const IntegrationRecord = z.object({
  integration: IntegrationItems,
});

export type IntegrationRecord = z.infer<typeof IntegrationRecord>;
